<ui-collapse collapseExpandIconPosition="right">
  <ui-collapse-panel
    *ngFor="let currReflection of currCheckInsModified; let i = index; trackBy: trackByMethod"
    [id]="'check-in-' + currReflection.assignee.id"
    [uiAssigneeNameSuffix]="currReflection.isCurrentUser ? 'me' : ''"
    [uiLabels]="!currReflection.isActive && (currReflection.labels | filterLabels : filter)"
    [uiIcon]="(!currReflection.isActive || !compareMode) && !currReflection.isEditing && currReflection.mood"
    [uiAssignee]="currReflection.assignee"
    [collapsePanelActive]="currReflection.isActive"
    [uiIsExpandable]="isPanelEnabled({ isCurrReflectionEmpty: currReflection.noReflection, isPrevReflectionEmpty: prevCheckInsModified[i]?.noReflection, isEditable: currReflection.isEditable })"
    [uiIsCustomHeader]="(!currReflection.isActive && compareMode && !isCheckInsUxImprovementsEnabled) || isCheckInsUxImprovementsEnabled"
    [ngStyle]="{
      'pointer-events': isPanelEnabled({
        isCurrReflectionEmpty: currReflection.noReflection,
        isPrevReflectionEmpty: prevCheckInsModified[i]?.noReflection,
        isEditable: currReflection.isEditable
      })
        ? 'initial'
        : 'none'
    }"
    [attr.data-test-id]="'check-in-collapse-panel-of-user-' + currReflection.assignee.name"
    (nzActiveChange)="activeChanged({ active: $event }, currReflection.assignee.id)"
    collapsePanelExpandedIcon="chevron-right-big">
    <ng-container
      [ngTemplateOutlet]="compareMode ? compareModeTemplate : defaultModeTemplate"
      [ngTemplateOutletContext]="{ currReflection: currReflection, prevReflection: prevCheckInsModified[i], index: i }"></ng-container>

    <ng-container header>
      <ng-container *ngIf="!compareMode">
        <ng-container *ngIf="isCheckInsUxImprovementsEnabled">
          <ui-assignee class="overview-panel-assignee" *ngIf="currReflection.assignee" [uiAssignee]="currReflection.assignee" [uiNameEllipsis]="true" uiSize="sm"></ui-assignee>
          &nbsp;
          <span class="ui-assignee-name-suffix" *ngIf="currReflection.isCurrentUser">(me)</span>
          <div class="ui-collapse-panel-header-extras">
            <div class="ui-collapse-panel-header-extras-icon">
              <i *ngIf="!currReflection.isEditing && currReflection.mood" [class]="currReflection.mood" [uiType]="currReflection.mood" ui-icon></i>
            </div>
            <reflection-label-group
              class="sp-mr-16"
              *ngIf="!currReflection.isActive"
              [ngStyle]="{ flex: 'none' }"
              [labels]="currReflection.labels | filterLabels : filter"
              [maxVisible]="maxVisibleLabels"></reflection-label-group>
          </div>
        </ng-container>
        <ng-container *ngIf="!isCheckInsUxImprovementsEnabled">
          <ui-assignee [uiAssignee]="currReflection.assignee" [uiNameEllipsis]="true" uiSize="sm"></ui-assignee>
          <reflection-label-group [labels]="prevCheckInsModified[i]?.labels | filterLabels : filter"></reflection-label-group>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="compareMode">
        <ui-assignee *ngIf="!isCheckInsUxImprovementsEnabled" [uiAssignee]="currReflection.assignee" [uiNameEllipsis]="true" uiSize="sm"></ui-assignee>
        <ui-assignee class="compare-mode-enabled" *ngIf="isCheckInsUxImprovementsEnabled" [uiAssignee]="currReflection.assignee" [uiNameEllipsis]="true" uiSize="sm"></ui-assignee>
        <div class="labels" *ngIf="!currReflection.isActive">
          <reflection-label-group *ngIf="!isCheckInsUxImprovementsEnabled" [labels]="prevCheckInsModified[i]?.labels | filterLabels : filter"></reflection-label-group>
          <reflection-label-group *ngIf="isCheckInsUxImprovementsEnabled" [labels]="prevCheckInsModified[i]?.labels | filterLabels : filter" [maxVisible]="maxVisibleLabels"></reflection-label-group>
          <div class="labels-separator"></div>
          <reflection-label-group *ngIf="!isCheckInsUxImprovementsEnabled" [labels]="currReflection.labels | filterLabels : filter"></reflection-label-group>
          <reflection-label-group *ngIf="isCheckInsUxImprovementsEnabled" [labels]="currReflection.labels | filterLabels : filter" [maxVisible]="maxVisibleLabels"></reflection-label-group>
        </div>
      </ng-container>
    </ng-container>
  </ui-collapse-panel>
</ui-collapse>

<ng-template #defaultModeTemplate let-currReflection="currReflection" let-index="index">
  <div class="sp-px-8 default-mode-template" *ngIf="!currReflection.indicators?.loadingIndicator" data-test-id="check-in-item-content">
    <ng-container *ngIf="!filter || filter === 'published'">
      <reflection-mood
        *ngIf="(currReflection.isEditing && currReflection?.settings?.moodsEnabled) || (currReflection.noReflection && checkInTemplate.moodsEnabled)"
        [isEditModeEnabled]="currReflection.isEditing"
        [reflectionMood]="currReflection.mood"
        (moodChange)="onMoodUpdate({ type: 'current', mood: $event }, index)"></reflection-mood>
      <ng-container *ngFor="let question of currReflection.questions; let i = index">
        <reflection-question
          *ngIf="(question.answer || currReflection.isEditing || question?.gif?.id) && question.isEnabled"
          [question]="question"
          [autofocus]="i === 0"
          [isEditModeEnabled]="currReflection.isEditing"
          [attr.data-test-id]="'check-in-question-' + question.question"
          (answerUpdate)="onAnswerUpdate({ type: 'current', question: $event }, index)"></reflection-question>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="currReflection?.settings?.notesEnabled || (currReflection.noReflection && checkInTemplate.notesEnabled)">
      <ng-container *ngFor="let note of currReflection.notes | filterNotes : filter; let i = index">
        <reflection-note
          *ngIf="note.text || currReflection.isEditing || note?.gif?.id"
          [note]="note"
          [isEditModeEnabled]="currReflection.isEditing && !filter"
          [attr.data-test-id]="'check-in-note-' + note.type"
          (noteChange)="onNoteUpdate({ type: 'current', note: $event, noteIndex: i }, index)"></reflection-note>
      </ng-container>
    </ng-container>

    <checkin-action-buttons
      class="sp-mt-8"
      *ngIf="!filter && currReflection.isEditable"
      [checkIn]="currReflection"
      [isCheckInEmpty]="isReflectionEmpty(currReflection)"
      (checkInPublish)="onPublishReflection($event, index)"
      (checkInEdit)="onEditReflection($event, index)"
      (checkInCancel)="onCancelReflection($event, index)"
      type="current"></checkin-action-buttons>
  </div>
  <gh-indicator class="sp-mb-32 sp-mt-16" [(ghValue)]="currReflection.indicators.loadingIndicator" [align]="'center'" [ghMessage]="'loading' | localize"></gh-indicator>
</ng-template>

<ng-template #compareModeTemplate let-currReflection="currReflection" let-prevReflection="prevReflection" let-index="index">
  <reflection-compare
    class="sp-px-8"
    *ngIf="!currReflection?.indicators?.loadingIndicator && !prevReflection?.indicators?.loadingIndicator"
    [checkInTemplate]="checkInTemplate"
    [currReflection]="currReflection"
    [prevReflection]="prevReflection"
    [filter]="filter"
    [currCadenceStartDate]="currCadenceStartDate"
    [prevCadenceStartDate]="prevCadenceStartDate"
    (moodUpdate)="onMoodUpdate($event, index)"
    (noteUpdate)="onNoteUpdate($event, index)"
    (answerUpdate)="onAnswerUpdate($event, index)"
    (fillOut)="onFillOut($event, index)"
    (edit)="onEditReflection($event, index)"
    (cancelEdit)="onCancelReflection($event, index)"
    (publish)="onPublishReflection($event, index)">
  </reflection-compare>
  <gh-indicator
    class="sp-mb-32 sp-mt-16"
    *ngIf="currReflection?.indicators?.loadingIndicator"
    [(ghValue)]="currReflection.indicators.loadingIndicator"
    [align]="'center'"
    [ghMessage]="'loading' | localize"></gh-indicator>
  <gh-indicator
    class="sp-mb-32 sp-mt-16"
    *ngIf="prevReflection?.indicators?.loadingIndicator"
    [(ghValue)]="prevReflection.indicators.loadingIndicator"
    [align]="'center'"
    [ghMessage]="'loading' | localize"></gh-indicator>
</ng-template>

<div class="sp-mt-20" *ngIf="maxReflectionsLength > pageSize">
  <reflection-pagination [pageIndex]="currentPage" [total]="maxReflectionsLength" [pageSize]="pageSize" (pageIndexChange)="onPageIndexChange($event)"></reflection-pagination>
</div>
